import { applyAlgorithmToState, applyMoveToState, invertMove } from '../core/moves.js';
import { applyAlgorithmToState4x4, applyMoveToState4x4, invertMove4x4 } from '../core/moves-4x4.js';

function cloneStickers(stickers) {
  return structuredClone(stickers);
}

export class PlaybackSession {
  constructor({ initialStickers, moves, formula, durationMs = 0, order = 3, speed = 1 }) {
    if (![2, 3, 4].includes(order)) throw new RangeError('播放器只支持 2×2、3×3 或 4×4');
    this.order = order;
    this.initialStickers = cloneStickers(initialStickers);
    this.currentStickers = cloneStickers(initialStickers);
    this.moves = [...moves];
    this.formula = formula;
    this.solveDurationMs = durationMs;
    this.step = 0;
    this.speed = speed;
    this.playing = false;
    this.transitioning = false;
  }

  get totalSteps() {
    return this.moves.length;
  }

  get currentMove() {
    return this.step > 0 ? this.moves[this.step - 1] : null;
  }

  get nextMove() {
    return this.step < this.totalSteps ? this.moves[this.step] : null;
  }

  prepareAdjacentStep(targetStep) {
    if (Math.abs(targetStep - this.step) !== 1) throw new RangeError('相邻播放一次只能移动一步');
    if (targetStep < 0 || targetStep > this.totalSteps) throw new RangeError('播放步骤超出范围');
    const forward = targetStep > this.step;
    const invert = this.order === 4 ? invertMove4x4 : invertMove;
    const applyMove = this.order === 4 ? applyMoveToState4x4 : applyMoveToState;
    const move = forward ? this.moves[this.step] : invert(this.moves[this.step - 1]);
    return {
      move,
      targetStep,
      nextStickers: applyMove(this.currentStickers, move),
    };
  }

  commitTransition(transition) {
    this.currentStickers = transition.nextStickers;
    this.step = transition.targetStep;
  }

  jumpTo(targetStep) {
    if (!Number.isInteger(targetStep) || targetStep < 0 || targetStep > this.totalSteps) {
      throw new RangeError('播放步骤超出范围');
    }
    const applyAlgorithm = this.order === 4 ? applyAlgorithmToState4x4 : applyAlgorithmToState;
    this.currentStickers = applyAlgorithm(this.initialStickers, this.moves.slice(0, targetStep));
    this.step = targetStep;
    return this.currentStickers;
  }
}
